import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {createState, select, Store, withProps} from '@ngneat/elf';
import {map, tap} from 'rxjs/operators';
import orderBy from 'lodash-es/orderBy';
import {SelectItemGroup} from 'primeng/api';
import {groupBy} from 'lodash-es';
import {TicketOption, TicketRepository} from '../repositories/ticket.repository';

export interface TicketState {
    options?: TicketOption[];
    names?: Map<string, string>;
}

const {state, config} = createState(withProps<TicketState>({
    options: [],
    names: new Map<string, string>(),
}));

const store = new Store({name: 'ticketStore', state, config});

const getState = () => store.getValue();

const updateState = (newState: Partial<TicketState>) => {
    store.update(s => ({...s, ...newState}));
};

// const persist = persistState(store, {
//     key: 'ticket',
//     storage: localStorageStrategy,
// });

@Injectable({
    providedIn: 'root'
})
export class TicketService {
    groupedOptions$ = store.pipe(select((({options}) => {
        const groupByStatus = groupBy(options, 'status');
        const sig: SelectItemGroup[] = [
            {label: 'OPEN', items: orderBy(groupByStatus.OPEN, 'name')},
            {label: 'CLOSE', items: orderBy(groupByStatus.CLOSE, 'name')},
        ];
        return sig;
    })));

    constructor(private repository: TicketRepository) {
    }

    getName(ticketId: string) {
        if (getState().names) {
            return getState().names.get(ticketId) ?? '---Not Found--';
        } else {
            this.fetchAllName().subscribe();
            return '---Not Load--';
        }
    }

    public fetchAllName(): Observable<TicketOption[]> {
        if (getState().options.length > 0) {
            return of(getState().options);
        } else {
            return this.repository.fetchNames().pipe(
                tap(options => {
                    updateState({options});
                }),
                tap(options => {
                        const getName = (c: TicketOption) => c.status === 'OPEN' ? c.label : `${c.label}[${c.status}]`;

                        const names = new Map<string, string>();
                        options.forEach(c => names.set(c.value, getName(c)));

                        updateState({names});
                    }
                )
            );
        }
    }
}
